import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { FaqDtoImpl } from '../../../../core/dto/faq/faqdto';
import { FaqResponse } from '../../../../core/api/faq/faqresponse';
import { FaqRequestImpl } from '../../../../core/api/faq/faqrequest';

export interface FAQAPIModel extends APIModel
{
    getFAQ(): void;
}

export class FAQAPIModelImpl extends APIModelImpl implements FAQAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }

    getFAQ(): void
    {
        this.getAPIProcesssorFactory().getFaqProcessorFactory().getFaqDetails()
        .success((getFAQResponse: FaqResponse)=>
        {
            this.getAPIModelHandler().onSuccess(getFAQResponse.getAPIFeature(), 
            getFAQResponse.getDescription(), getFAQResponse.getFaqDtos());
          
         })
        .failure((getFAQResponse: FaqResponse)=>
         {
           this.getAPIModelHandler().onFailure(getFAQResponse.getAPIFeature(), 
           getFAQResponse.getDescription(), undefined);
         })
        .execute(new FaqRequestImpl(new FaqDtoImpl()));
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/faq/faqapimodel.ts